module.exports = __webpack_public_path__ + "img/图片2.8f1a9e14.png";